import usePotreeViewer from "./usePotreeViewer";

const usePotreeMeasurements = () => {
  const { viewer } = usePotreeViewer();

  const startDistanceMeasurement = ({ name }) => {
    viewer.measuringTool.startInsertion({
      showDistances: false,
      showArea: false,
      closed: false,
      name: name,
      measureType: "distance",
    });
  };

  const startVolumeMeasurement = ({ name }) => {
    viewer.measuringTool.startInsertion({
      showDistances: false,
      showPolygonVolume: true,
      closed: true,
      name: name,
      measureType: "volume",
    });
  };

  const startPointMeasurement = ({ name }) => {
    console.log("startPointMeasurement");

    viewer.measuringTool.startInsertion({
      showDistances: false,
      showCoordinates: true,
      showArea: false,
      showAngles: false,
      closed: true,
      maxMarkers: 1,
      name: name,
      measureType: "point",
    });
  };

  const startAreaMeasurement = () => {
    viewer.measuringTool.startInsertion({
      showDistances: true,
      showArea: true,
      closed: true,
      name: "Area",
    });
  };

  const stopMeasurement = () => {
    viewer.measuringTool.stopInsertion();
  };

  const clearMeasurements = () => {
    viewer.scene.removeAllMeasurements();
  };

  const exportMeasurements = () => {
    viewer.measuringTool.export();
  };

  const addMeasurement = (measurement) => {
    viewer.scene.addMeasurement(measurement);
  };

  const removeMeasurement = (measurement) => {
    viewer.scene.removeMeasurement(measurement);
  };

  const setMeasurementVolumeResult = (measurementId, result) => {
    const measurement = viewer.scene.measurements.find(
      (m) => m.uuid === measurementId,
    );

    measurement.setVolumeResult(result);
  };

  const setMeasurementVolumeResultState = (measurementId, state) => {
    const measurement = viewer.scene.measurements.find(
      (m) => m.uuid === measurementId,
    );

    measurement.setVolumeResultState(state);
  };

  return {
    startPointMeasurement,
    startDistanceMeasurement,
    startAreaMeasurement,
    startVolumeMeasurement,
    stopMeasurement,
    exportMeasurements,
    clearMeasurements,
    removeMeasurement,
    addMeasurement,
    setMeasurementVolumeResult,
    setMeasurementVolumeResultState,
    getPotreeMeasurements: () => viewer.scene.measurements,
  };
};

export default usePotreeMeasurements;
